// material-ui
import { Divider, Stack, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

const Footer = () => (
  <Stack mt={4} mb={4} direction="column" justifyContent="space-between" alignItems="center">
    <Divider width='100%' sx={{borderColor:'#ccc'}} />
    <Stack width='100%' direction="row" justifyContent="space-between" alignItems="center" sx={{ p: '24px 16px 0px', mt: 'auto' }}>
      <Typography variant="caption" color='#bbb'>
        Sistema de administración {process.env.REACT_APP_STORE_NAME} {process.env.REACT_APP_STORE_ID} {process.env.REACT_APP_STORE_VERSION}
      </Typography>
      <Stack direction="row" spacing={2} alignItems="center">
        <Link to="/logout" style={{ color: '#bbb', fontSize: '0.75rem', textDecoration: 'none' }}>Cerrar sesión</Link>
        <Typography variant="caption" color='#bbb'>
          Worten SAAS {process.env.REACT_APP_FRAMEWORK_VERSION} | Build {process.env.REACT_APP_BUILD}
        </Typography>
      </Stack>
    </Stack>
  </Stack>
);

export default Footer;
